/**
 * Comutatorul wizardului de inscriere OTP-first (p8, planul b30/p8 din 2026-09-10).
 *
 * OPRIT implicit, si citit o singura data, aici -- acelasi tipar ca `video-flag.ts` si
 * `protocol-flag.ts`: `VITE_*` se inline-uieste la BUILD, deci un `if` imprastiat prin
 * componente ar sugera o valoare care se schimba la runtime, cand nu se schimba.
 *
 * Cat timp e oprit, ruta `InregistrareCodPage` nu se inregistreaza deloc (vezi
 * `routes-provider`), deci fara flag bundle-ul se comporta identic cu PROD.
 */
/* 🔴 Scris EXACT asa, fara cast si fara acces indirect -- Vite inlocuieste textual
   `import.meta.env.VITE_...` la build; un acces indirect (`(import.meta as {...}).env?....`)
   compileaza dar nu se mai potriveste inlocuirii, si flagul ramane mereu oprit in bundle. */
export const INREGISTRARE_COD_ACTIV =
    String(import.meta.env.VITE_INREGISTRARE_COD ?? '').toLowerCase() === 'true';
